import { ProductCodeRange } from './LeadProducts';
import { PaymentStatusCode, TransactionStatus } from './StatusCode';

export class ContractModel {
  PlanId: number;
  Branch: string;
  CommercialName: string;
  ProductImageUrl: string;
  ContractReserve: number;
  TotalInvested: number;
  TotalTransactionsIn: number;
  TotalTransactionsOut: number;
  GainLossValue: number;
  GainLossPercentage: number;
  //NumberOfUnits: number;
  //ValuePerUnit: number;
  BankAccountExceptionalPayment: string;
  PermanentPaymentReference: string;
  PartnershipId: number;
  FundName: string;
  ShowReceivedPaymentMessageForBR23?: boolean;
  IsStopLoss: boolean;
  ProductRange?: ProductCodeRange;
  BeneficiaryChildLastName?: string;
  BeneficiaryChildFirstName?: string;
  BeneficiaryChildDateOfBirth?: Date;
  ContractCancellationStatus?: ContractCancellationStatus;
}

export class CustomerContractDetailsViewModel {
  ContractExternalReference: string;
  ContractStartDate: Date;
  ContractEndDate: Date;
  ContractDurationNl: string;
  ContractDurationFr: string;
  FundName: string;
  FundLinkNl: string;
  FundLinkFr: string;
  BeneficiaryClauseNl: string;
  BeneficiaryClauseFr: string;
  ProductRange: ProductCodeRange;
  AwaitingPromoCodeContribution: boolean;
  ValuePerUnit: number;
  NumberOfUnits: number;
}

export class ContractDataViewModel {
  RecurrentPaymentAmount: number;
  CurrentNextDueDate: string; //New due date - Modify Amount
  NextdueDateChangeBankAccount: string; //New due date - Change Bank Account
  RecurrentPaymentBankAccount: string;
  Transactions: TransactionData[];
  IsRecurrentPaymentAvailable: boolean;
  IsPaymentReceived: boolean;
  IsPaymentProcessing: boolean;
  TransactionReferenceNumber: string;
  HasMoreThenOneActiveRecurrentPayment?: boolean;
}

export class TransactionData {
  TransactionDate: string;
  TransactionType: number;
  Amount?: number;
  ContributionID: number;
  TypeText_FR?: string; // will be pushed from FE
  TypeText_NL?: string; // will be pushed from FE
  PaymentFees?: number | string; // string for formatting
  PaymentTaxes?: number | string;
  PaymentNetAmount?: number | string;
  PaymentStatus?: PaymentStatusCode;
  TransactionStatus: TransactionStatus;
  TransactionReferenceNumber: string;
  isPlusRequired?: boolean; // will be pushed from FE
  StopLossTransactionId: number;
  StopLossAmount?: number; //will be pushed from FE
}

export interface ContractDataTransactionViewModel {
  TransactionDate: Date;
  TransactionType: PaymentCode;
  PaymentGrossAmount?: number;
  PaymentTaxes?: number;
  PaymentFees?: number;
  PaymentNetAmount?: number;
  SurrenderGrossAmount?: number;
  SurrenderTaxes?: number;
  SurrenderFees?: number;
  SurrenderNetAmount?: number;
}

export enum PaymentCode {
  OneShotOnline = 0,
  BasketOnline = 1,
  Recurrent = 2,
  Direct = 3,
  PromotionalCode = 4,
  MoneyIn = 5,
  MoneyOut = 6,
  ContractYield = 7,
  Surrender = 8,
  StopLossTransferActivate = 9,
  StopLossTransferDeactivate = 10
}

export const TransactionTypeMapping = [
  {
    TypeCode: PaymentCode.Recurrent,
    TypeText_FR: 'Domiciliation',
    TypeText_NL: 'Domiciliëring'
  },
  {
    TypeCode: PaymentCode.Direct,
    TypeText_FR: 'Versement',
    TypeText_NL: 'Storting'
  },
  {
    TypeCode: PaymentCode.OneShotOnline,
    TypeText_FR: 'Versement',
    TypeText_NL: 'Storting'
  },
  {
    TypeCode: PaymentCode.Surrender,
    TypeText_FR: 'Retrait',
    TypeText_NL: 'Opname'
  },
  {
    TypeCode: PaymentCode.ContractYield,
    TypeText_FR: 'Participation bénéficiaire',
    TypeText_NL: 'Winstdeling'
  },
  {
    TypeCode: PaymentCode.BasketOnline,
    TypeText_FR: 'Paiement en ligne',
    TypeText_NL: 'Online betaling'
  },
  {
    TypeCode: PaymentCode.MoneyOut,
    TypeText_FR: 'Retrait',
    TypeText_NL: 'Opname'
  },
  {
    TypeCode: PaymentCode.PromotionalCode,
    TypeText_FR: 'Action commerciale',
    TypeText_NL: 'Commerciële actie'
  },
  {
    TypeCode: PaymentCode.StopLossTransferActivate,
    TypeText_FR: 'Mécanisme de protection',
    TypeText_NL: 'Beschermingsmechanisme'
  },
  {
    TypeCode: PaymentCode.StopLossTransferDeactivate,
    TypeText_FR: 'Mécanisme de protection',
    TypeText_NL: 'Beschermingsmechanisme'
  }
];

export class StopLossTransactionData {
  YongoNeutralFund: number
}



export type PaymentDetailsContractData = {
  currentNextDueDate: string,
  currentAmount: number,
  planID: number,
  contractRef: string,
  iban: string,
  isIbanModificationRetry?: boolean,
  nextdueDateChangeBankAccount?: string,
  HasMoreThenOneActiveRecurrentPayment?: boolean,
  branchId: string
};

export interface PaymentDetails {
  planId?: number,
  productCodeRange: number,
  partnerId: number,
  ContractExternalReference: string,
  amount?: number
}

export enum OnlinePaymentEntryPage {
  EsignatureConfirmation = 1,
  CustomerZone = 2,
  ContractDetails = 3
}

export enum ContractCancellationStatus {
  CanBePrecancelled = 0,
  IsPrecancelled = 1,
  CannotBePrecancelled = 2
}

export class CreateOnlinePaymentRequestModel {
  amount: number;
  RedirectURL: string;
  SuccessUrl: string;
  FailureUrl: string;
  AGProfile: string;
  ContractExternalReference: string;
  PersonId: number;
}

export class CreateOnlinePaymentResponseModel {
  OnlinePaymentCodbGuid: string;
  OnlinePaymentId: string;
  BaseUrl: string
}

export interface onlinePaymentHandler {
  state: string,
  accessToken?: string
}

export interface OnlinePaymentInfo {
  entryPoint: OnlinePaymentEntryPage,
  amount: number,
  IsRedirectedToUPScreen: boolean,
  isPaymentStatusCalled: boolean
  onlinePaymentID: string,
  onlinePaymentCODBGUID: string,
  baseURL: string,
  planId: number
}
